import { useMemo } from "react";
import { getPagesOptions } from "../getPagesOptions/getPagesOptions";

export interface UseListPaginationParams {
  currentPage: number;
  totalPages: number;
}

const FIRST_PAGE_NUMBER = 1;

export const useListPagination = ({ currentPage, totalPages }) => {
  const paginationInfo = useMemo(
    () => ({
      nextPage: currentPage + 1,
      previousPage: currentPage - 1,
      hasPreviousPage: currentPage > FIRST_PAGE_NUMBER,
      hasNextPage: currentPage < totalPages,
      pagesOptions: getPagesOptions({ currentPage, totalPages }),
    }),
    [currentPage, totalPages]
  );

  return paginationInfo;
};
